/*
 * Cart drawer extras (GrillDaddy custom):
 *  - <gd-cart-shipbar>: free shipping progress bar, updates on every cart change.
 *  - <gd-cart-upsell>: one-tap add buttons; hides products already in the cart.
 *
 * Both listen to Minimog's "cart-update" pub/sub event and also poll cart.json
 * on drawer open, so they stay accurate regardless of how the cart changed.
 */
(function () {
  function money(cents, format) {
    if (typeof window.formatMoney === 'function') {
      try {
        return window.formatMoney(cents, format);
      } catch (e) {
        /* fall through */
      }
    }
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }

  function fetchCart() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function onCartEvents(handler) {
    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, handler);
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.openCartDrawer, handler);
    }
  }

  if (!window.customElements.get('gd-cart-shipbar')) {
    window.customElements.define(
      'gd-cart-shipbar',
      class extends HTMLElement {
        connectedCallback() {
          this.threshold = parseInt(this.dataset.threshold, 10) || 0;
          this.msgEl = this.querySelector('[data-shipbar-msg]');
          this.fillEl = this.querySelector('[data-shipbar-fill]');
          this.refresh = this.refresh.bind(this);
          onCartEvents(this.refresh);
        }

        refresh() {
          var self = this;
          fetchCart().then(function (cart) {
            var total = cart.total_price;
            var pct = self.threshold > 0 ? Math.min(100, Math.round((total / self.threshold) * 100)) : 100;
            if (self.fillEl) self.fillEl.style.width = pct + '%';
            var unlocked = total >= self.threshold;
            self.classList.toggle('is-unlocked', unlocked);
            if (self.msgEl) {
              if (unlocked) {
                self.msgEl.innerHTML = '<strong>' + self.dataset.unlockedText + '</strong>';
              } else {
                var remaining = money(self.threshold - total, self.dataset.moneyFormat);
                self.msgEl.textContent = self.dataset.progressText.replace('[amount]', remaining);
              }
            }
          });
        }
      }
    );
  }

  if (!window.customElements.get('gd-cart-upsell')) {
    window.customElements.define(
      'gd-cart-upsell',
      class extends HTMLElement {
        connectedCallback() {
          this.refresh = this.refresh.bind(this);
          this.addEventListener('click', this.onClick.bind(this));
          onCartEvents(this.refresh);
          this.refresh();
        }

        refresh() {
          var self = this;
          fetchCart().then(function (cart) {
            var inCart = {};
            cart.items.forEach(function (item) {
              inCart[item.product_id] = true;
            });
            var visible = 0;
            self.querySelectorAll('[data-upsell-product-id]').forEach(function (row) {
              var hide = !!inCart[parseInt(row.dataset.upsellProductId, 10)];
              row.style.display = hide ? 'none' : '';
              if (!hide) visible++;
            });
            self.style.display = visible === 0 ? 'none' : '';
          });
        }

        onClick(event) {
          var btn = event.target.closest('[data-upsell-add]');
          if (!btn) return;
          btn.disabled = true;
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.upsellAdd, 10), quantity: 1 }] }),
          })
            .then(function (r) {
              return r.json();
            })
            .then(function () {
              var drawer = document.getElementById('MinimogCartDrawer');
              if (drawer && typeof drawer.onCartDrawerUpdate === 'function') {
                drawer.onCartDrawerUpdate();
              }
              if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
                window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, {});
              }
            })
            .catch(function (e) {
              console.error('[gd-cart-upsell] add failed', e);
            })
            .finally(function () {
              btn.disabled = false;
            });
        }
      }
    );
  }
})();
